import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userRoles']),
  },
  methods: {
    hasRole(role) {
      return this.userRoles.includes(role)
    },
    hasAnyRole(roles = []) {
      return roles.some(role => this.userRoles.includes(role))
    },
    hasAllRoles(roles = []) {
      return roles.every(role => this.userRoles.includes(role))
    },
  },
}
